export default {
  "meeting": {
    applyrecurring: 'Les modifications seront appliquées à la nouvelle planification récurrente. Les réunions passées ne seront pas modifiées.',
    recurrenceDescribeTwo: 'Se produit toutes les {loopPulse} semaines le {week}, du {start} au {end}',
    wanttodeletethemeetingfollowTwo: 'Supprimer la réunion sélectionnée ainsi que toutes les réunions récurrentes suivantes ?',

    loopCycleSelectTips: 'Veuillez sélectionner le jour de la semaine où la répétition doit avoir lieu.',

    export: 'Exporter',
    exportMeetingFileFuncTipsTitle: 'Confirmation d’exportation',
    exportMeetingFileFuncTipsContentOne: 'Aucun filtre n’est appliqué. Le système exportera par défaut les enregistrements des réunions de l’année en cours.',
    exportMeetingFileFuncTipsContentTwo: 'Pour exporter des réunions d’une autre période, veuillez appliquer les filtres souhaités avant l’exportation.',

    myMeetingSearch: 'Mes réunions',
    meetingTimeSearch: 'Heure de réunion',
    meetingRoomsSearch: 'Salle de réunion',

    Recurring: 'Récurrent :',
    wanttodeletethemeetingfollow: 'Êtes-vous sûr de vouloir supprimer cette réunion et toutes les réunions suivantes ?',
    endTimeCannotBeforeBeginTime: 'La date de fin ne peut pas être antérieure à la date de début',
    Thismeeting: 'Cette réunion',
    Recurringmeeting: 'Réunion récurrente',
    Checkin: 'Enregistrement :',
    checkinTip: 'Après activation, les participants peuvent s’enregistrer en scannant le code QR du planificateur de salles.',
    Recurrence_Setrecurrence: 'Définir la récurrence',
    Recurrence_Start: 'Début',
    Recurrence_RepeatEvery: 'Répéter tous les',
    Recurrence_Week: 'Semaine',
    Recurrence_end: 'Fin',
    recurrenceDescribe: 'Se produit toutes les {week} à partir du {start} jusqu’au {end}',
    Recurrence_DoesnotRepeat: 'Ne pas répéter',
    Recurrence_Weekly: 'Hebdomadaire',

    AddressBookUser: 'Utilisateur',
    AddressBookPhonebook: 'Carnet d’adresses',

    RoomByPeopleNum1: '2 personnes ou moins',
    RoomByPeopleNum2: '3-6 personnes',
    RoomByPeopleNum3: '7-10 personnes',
    RoomByPeopleNum4: '11-15 personnes',
    RoomByPeopleNum5: '16-20 personnes',
    RoomByPeopleNum6: '21-30 personnes',
    RoomByPeopleNum7: 'Plus de 30 personnes',

    whoAreBound: 'Les utilisateurs liés à un compte système verront la réunion dans le calendrier du système. Les utilisateurs ayant fourni une adresse e-mail recevront des notifications de réunion par e-mail. Pour recevoir des notifications par e-mail, veuillez compléter vos informations dans [Mon profil].',

    AttendessMeeting: 'Participants:',
    SelectAttendessMeetingTip: 'Sélectionner des participants',

    MeetingFilter: 'Filtre de réunion',
    HostedbyMe: 'Organisé par moi',
    Invitedby: 'Invité par moi',
    Otherby: 'Autres',

    "AddressIsDuplicated": "L'e-mail du contact est dupliqué",
    "meetingExpired": "Expiré",
    titlePhoneFormat: 'Le téléphone ne peut contenir que des chiffres, () + et -.',
    "selectField": "Veuillez sélectionner un fichier",
    "Limit255": "Le nom du fichier ne peut pas dépasser 255 caractères",
    "nameLimit25": "Le nom ne peut pas dépasser 25 caractères",
    "emailLimit50": "L’email ne peut pas dépasser 50 caractères",
    "emailFormatError": "Veuillez entrer une adresse email valide",
    "phoneLimit11": "Le numéro de téléphone peut contenir jusqu’à 11 chiffres",
    "ParticipantsEmail": "Email du participant :",
    "listIsEmpty": "La liste est vide",
    "Startimporting": "Commencer le téléchargement",
    "Selectfile": "Sélectionner un fichier",
    "Importfile": "Importer le fichier",
    "ImportfileTip": "*Seuls les fichiers CSV au format Outlook (.csv) ou vCard (.vcf) sont pris en charge pour l’importation.",
    "addParticipants": "Ajouter un participant",
    "multiselectdeselect": "Indication de suppression de balise",
    "multiselectselected": "Indication de sélection",
    "enterOrSelectALabel": "Sélectionnez l’email du participant",
    "deleTitleContact": "Êtes-vous sûr de vouloir supprimer ce contact ?",
    "delTitleContactContent": "Supprimer le contact ?",
    "deleteContactTitle": "Veuillez sélectionner le contact à supprimer",
    "editcontact": "Modifier le contact",
    "Name": "Nom",
    "email": "Email",
    "telephoneNumber": "Téléphone",
    "Addcontact": "Ajouter un contact",
    "Importcontactfile": "Importer des contacts",
    "AddressBook": "Carnet d’adresses",
    "Participants": "Participants :",

    bindTipContent:"Cette organisation a déjà lié un calendrier tiers. Veuillez planifier les réunions via Outlook/Teams.",
    Productupdatenews: 'Une nouvelle mise à jour de version a été publiée. ',
    bookingPerson: 'Réservé par',
    "DeleteMeeting": "Supprimer la réunion",
    "wanttodeletethemeeting": "Voulez-vous supprimer la réunion ?",
    "hasbeendeleted": "La réunion a été supprimée",
    "theMeetingWasAborted": "Terminer la réunion plus tôt",
    "theMeetingWasAbortedContent": "Voulez-vous terminer la réunion plus tôt ?",
    "determineTheAbortTask": "Terminer la réunion plus tôt",
    "theMeetingEndedEarly": "La réunion a été terminée plus tôt.",
    "with": "avec",
    "Other": "Autre",
    "tasks": "conflit de tâches",
    "conflict": "Le créneau horaire suivant entre en conflit :",
    "meetConflicts": "Les horaires passés ne peuvent pas être sélectionnés",
    "itIsNotAllowedToSelectThePastTime": "Sélectionné",
    "selected": "Sélectionnez pas plus de 5 salles de réunion",
    "noOverFive": "Avis d'approbation",
    "approvalOpinions": "Au-delà de la limite de temps, il ne peut pas être sélectionné",
    "beyondTheTimeLimitItCannotBeSelected": "Mois de début",
    "startMonth": "à",
    "to": "Mois de fin",
    "stopMonth": "Pas de début",
    "didnTStart": "En cours",
    "ONGOING": "Terminé",
    "ENDED": "a été",
    "hasBeen": "réservation",
    "booking": "Approbation",
    "Approval": "Salle de réunion",
    "MeetingRoom": "Toutes les salles",
    "AllRoom": "Disponible",
    "Available": "Initier la réunion",
    "Initiate": "Approbation de la réunion",
    "MeetingApproval": "Mois précédent",
    "PreviousMonth": "Aujourd'hui",
    "Today": "Mois suivant",
    "NextMonth": "Année/Mois",
    "YearMonth": "Affichage du temps",
    "TimeDisplay": "Abréviation du titre de la réunion",
    "MeetingTitleAbbreviation": "Initier la réunion",
    "InitiateMeeting": "Réunions à venir",
    "PendingMeetings": "Toutes les réunions",
    "AllMeetings": "Il n'y a pas de réunions à assister pour le moment",
    "noMeetings": "Non commencé",
    "NotStarted": "Organisateur",
    "Organizer": "Date & Heure",
    "MeetingDateTime": "Lieu",
    "MeetingLocation": "Sujet de la réunion",
    "MeetingSubject": "Personnes invitées",
    "Invited": "Personnes acceptées",
    "PeopleAccepted": "Modifier la réunion",
    "EditMeeting": "Annuler la réunion",
    "CancelMeeting": "Initier/Modifier la réunion",
    "InitiateEditMeeting": "Sujet",
    "Subject": "Sujet",
    "Presenter": "Présentateur :",
    "DateTime": "Date et Heure",
    "TimeAndZone": "Fuseau horaire",
    "Attendees": "Participants",
    "Addrequiredattendees": "Ajouter les participants requis",
    "SelectRooms": "Sélectionner des salles",
    "Reminder": "Rappel",
    "Remindbeforestart": "Rappeler avant le début",
    "Confirm": "Confirmer",
    "topic": "Sujet :",
    "topicplace": "Nouveau titre de réunion :",
    "speaker": "Présentateur :",
    "speakerplace": "Veuillez entrer les informations du présentateur",
    "DateAndTime": "Date & Heure :",
    "TimeZone": "Fuseau horaire",
    "EndDate": "Date de fin",
    "Rooms": "Salles :",
    "Notes": "Notes :",
    "MeetingRoomApproval": "Approbation de la salle de réunion",
    "PendingApproval": "En attente d'approbation",
    "Approved": "Approuvé",
    "nopendingapprovals": "Il n'y a pas d'approbations en attente",
    "Applicant": "Demandeur",
    "UsageTime": "Temps d'utilisation",
    "ApprovalResult": "Résultat de l'approbation",
    "ApprovalComments": "Commentaires sur l'approbation",
    "Approve": "Approuver",
    "Reject": "Rejeter",
    "Search": "Rechercher",
    "Filter": "Filtrer",
    "scanTheQRCodeToSignIn": "Scannez le code QR pour vous inscrire"
  },
  "NPS": {
    "Relay": "Relais",
    "RelaySettings": "Paramètres du relais",
    "DevicePower": "Contrôle de l'alimentation de l'appareil",
    "DeviceElevation": "Contrôle de l'élévation",
    "LinageWithNPSPower": "Liaison avec l'alimentation NPS",
    "PresentationSwitch": "Commutateur de présentation",
    "Duplicate": "Dupliquer",
    "LinkagewithNPSPowe": "Liaison avec l'alimentation NPS",
    "npsTooltip": "Les périphériques USB ne peuvent être appelés que par un PC hôte qui est commuté vers HDMI OUT 1.",
    "nmpTooltip": "Cliquez sur le bouton 'Dupliquer' pour refléter le contenu de l'écran sur d'autres écrans, synchronisant l'affichage sur plusieurs écrans."
  },
  "textTemplate": {
    "template2513": "Diffusion d'urgence incendie",
    "template2514": "Veuillez évacuer par la sortie de secours et la sortie incendie vers un endroit sûr conformément au plan d'évacuation incendie.",
    "moreTemplate": "Limite de modèle atteinte",
    "add": "Ajouter",
    "SetTemplate": "Définir le modèle",
    "Emergency": "Urgence",
    "General": "Général",
    "BroadcastDevices": "Dispositif de diffusion :",
    "selectBroadcastDevices": "Veuillez sélectionner les dispositifs de diffusion",
    "All": "Tout",
    "AddTemplate": "Ajouter un modèle",
    "EditTemplate": "Modifier le modèle",
    "deleteTemplage": "Êtes-vous sûr de vouloir supprimer le modèle sélectionné ?",
    "title": "Supprimer le modèle",
    "selectTemplage": "Veuillez sélectionner un modèle !",
    "DeleteCancelled": "Suppression annulée !",
    "DeletedSuccessfully": "Supprimé avec succès !",
    "noData": "Aucun modèle disponible, cliquez sur le coin supérieur droit pour ajouter un modèle.",
    "TemplateTitle": "Titre du modèle :",
    "BroadcastType": "Type de diffusion :",
    "BroadcastTypeDialog": "Type de diffusion :",
    "selectBroadcastType": "Veuillez sélectionner le type de diffusion",
    "BroadcastDuration": "Durée de la diffusion :",
    "BroadcastDevice": "Dispositif de diffusion :",
    "BroadcastContent": "Contenu de la diffusion :"
  },
  "common": {
    "mediaTimeStateNotifyErrorTitle": "Erreur !",
    "mediaTimeStateNotifyErrorContent": "Votre service de diffusion a expiré, veuillez contacter votre agent pour le renouveler à temps.",
    "mediaTimeStateNotifyWarnTitle": "Attention !",
    "mediaTimeStateNotifyWarnContent": "Vous êtes actuellement en période d'essai, vous ne pouvez diffuser et diffuser en direct que sur 3 appareils au maximum.",
    "mediaTimeStateNotifySuccessTitle": "Renouvellement réussi",
    "mediaTimeStateNotifySuccessContent": "Votre service de diffusion est prêt à être utilisé normalement. Merci.",
    "company": "Nom de l'entreprise :",
    "tableAddress": "Adresse :",
    "createTime": "Date de création :",
    "email": "Email :",
    "phone": "Téléphone :",
    "Trial": "Essai",
    "TrialWorkstation": "Vous êtes actuellement en période d'essai, vous ne pouvez diffuser et diffuser en direct que sur 3 appareils au maximum.",
    "Normal": "Normal",
    "NormalWorkstation": "La période de validité de votre service de diffusion est du",
    "to": "au",
    "Advent": "Avent",
    "AdventWorkstationOne": "Votre service de diffusion expirera le",
    "AdventWorkstationTwo": ", veuillez contacter votre agent pour le renouveler à temps pour une utilisation normale.",
    "Expired": "Expiré",
    "ExpiredWorkstation": "Votre service de diffusion a expiré, veuillez contacter votre agent pour le renouveler à temps."
  },
  "route": {
    "dashboard": "Tableau de bord",
    "i18n": "I18n",
    "Devices": "Appareils",
    "Broadcast": "Diffusion",
    "Schedule": "Calendrier",
    "Resources": "Ressources",
    "Live": "Direct",
    "meetings": "Réunion"
  },
  "navbar": {
    "updates":"Mises à jour récentes",
    "logOut": "Se déconnecter",
    "screenfull": "plein écran",
    "oprofile": "Mon profil",
    "settings": "Paramètres",
    "language": "Langue",
    "BackTianwa": "Retour à Tianwa",
    "newUserGuide": "Guide du nouvel utilisateur"
  },
  "feedback": {
    "Feedback": "Retour",
    "email": "Veuillez laisser votre e-mail pour notre retour.",
    "content": "Bienvenue et laissez des messages pour améliorer nos produits. Merci pour vos commentaires.",
    "submit": "Soumettre",
    "emailNoEmpty": "L'e-mail ne peut pas être vide",
    "emailTrueRule": "Veuillez entrer le bon format d'e-mail",
    "contentNoEmpty": "Le contenu ne peut pas être vide",
    "feedbackSuccess": "Retour réussi",
    "feedbackFailed": "Retour échoué",
    "emailNoChinese": "La boîte aux lettres ne peut pas contenir de caractères chinois",
    "emailLength": "Entre 5 et 50 caractères de longueur",
    "emailSpecialString": "La boîte aux lettres ne peut pas contenir de chaînes spéciales"
  },
  "login": {
    checkPasswordTitleTwo: 'Veuillez définir un mot de passe d’au moins 6 caractères, comprenant des lettres et des chiffres. Les caractères spéciaux sont autorisés (sans restriction).',
    captcha: 'Code de vérification',
    checkPasswordTitle: 'Le mot de passe doit comporter au moins 6 caractères et ne peut pas être uniquement des chiffres',
    "title": "BIENVENUE",
    "logIn": "Se connecter",
    "consoleLogin": "Connexion à la console",
    "username": "Nom d'utilisateur",
    "password": "Mot de passe",
    "any": "n'importe lequel",
    "thirdparty": "Ou se connecter avec",
    "thirdpartyTips": "Ne peut pas être simulé localement, donc veuillez combiner avec votre propre simulation d'entreprise !!!",
    "placeholder": ["Nom d'utilisateur","Mot de passe","Code de vérification"],
    "userNameTitle": "Nom d'utilisateur incorrect !",
    "forget": "Vous l'avez oublié ?",
    "loginTitle0": "Connexion réussie !",
    "loginTitle1000": "Nom d'utilisateur ou mot de passe incorrect !",
    "loginTitle1001": "Le nom d'utilisateur et le mot de passe doivent être remplis !",
    "loginTitle1002": "Le code de vérification doit être rempli !",
    "loginTitle1003": "Le statut de l'utilisateur est illégal, échec de la connexion !",
    "loginTitle1004": "Erreur de code de vérification !",
    "loginTitle1005": "Non connecté, veuillez vous connecter d'abord !",
    "loginTitle1006": "Les deux mots de passe sont différents !",
    "loginTitleUserName": "Le nom d'utilisateur doit être rempli !",
    "loginTitlePwd": "Le mot de passe doit être rempli !",
    "loginTitleVercode": "Le code de vérification doit être rempli !",
    "titleLoginNameFormat": "Le compte doit être constitué de caractères ou de caractères et de chiffres.",
    "privacy": "Q-NEX User Privacy Policy",
    "privacyContent": "Agree to",
    "_zh": "中文(简体)",
    "_en": "_English",
    "_ko": "한국어",
    "_zh_ft": "中文(繁體)"
  },
  "home": {
    "btnDevices": "Appareils",
    "btnRoadcast": "Diffusion",
    "btnResources": "Ressources",
    "btnLive": "Direct",
    "meetings": "Réunion",
    "todaySchedule": "Planning du jour",
    "allSkedules": "Tous les plannings",
    "details": "Détails",
    "btnStart": "Démarrer",
    "titleContent": "Bonjour! La console Q-NEX est à votre service. Commençons!",
    "btnExit": "Sortir"
  },
  "devices": {
    ptzCamera:'Caméra PTZ',
    "start": "DÉMARRER",
    "stop": "ARRÊTER",
    "nmpPowerOff_mandatory": "En diffusion (non obligatoire)",
    "nmpPowerOff_nomandatory": "En diffusion (non obligatoire). Continuer l'exécution ?",
    "nmpsPowerOff_mandatory": "Certains NMP sont en diffusion (obligatoire).",
    "nmpsPowerOff_nomandatory": "Certains NMP sont en diffusion (non obligatoire). Continuer l'exécution ?",
    "reset": "Réinitialiser",
    "displayedInTheControlArea": "Affiché dans le centre de contrôle",
    "dragOrder": "Faire glisser l'ordre",
    "areaSettingTwoNotice": "*Le contrôle RS232, AC, et la commande à distance sont affichés dans le centre de contrôle en fonction de l'état de liaison NMP dans le tableau de bord.",
    "areaSettingThreeNotice": "*Le contrôle CBX est affiché dans le centre de contrôle en fonction de l'état de liaison NMP dans le tableau de bord.",
    "controlSet": "Paramètres du centre de contrôle",
    "vcbNoLine": "Aucun appareil CBX n'est en ligne",
    "vcbNoBound": "Aucun appareil CBX n'est lié",
    "tscNoBound": "Le RS232 sur TSC n'est pas lié à des données. Veuillez informer l'administrateur pour le lier dans le tableau de bord.",
    "light": "Contrôle de l'alimentation",
    "vcbpower": "Alimentation",
    "rs232Control": "Contrôle Série",

    "CBX": {
    "powerSupplyON": "Allumer",
    "powerSupplyOFF": "Éteindre",
    "lockScreenON": "Verrouiller",
    "lockScreenOFF": "Déverrouiller",
    "childLockON": "Verrouillage enfant activé",
    "childLockOFF": "Verrouillage enfant désactivé",
    "energySavingON": "Économie d'énergie activée",
    "energySavingOFF": "Économie d'énergie désactivée",
    "signalSourceSwitchingON": "OPS",
    "signalSourceSwitchingOFF": "Android",
    "volumeAdjustment": "Haut-parleur",
    "brightAdjustment": "Luminosité",
    "other": "Autres fonctionnalités..."
    },

    "InterfaceOne": "Interface Un",
    "InterfaceTwo": "Interface Deux",
    "abcStyleP": "Désolé! TSC et (NMP, MBX, NPS, NDP100, NDP500) ne peuvent pas être sélectionnés en même temps",
    "masterControl": "principal",
    "powerSupply": "Puissance",
    "RecordingControl": "Contrôle d'enregistrement",
    "RecordingControlSystem": "Système de capture de conférence",
    "LiquidCrystal": "Écran LCD interactif",
    "projector": "Projecteur",
    "othertype": "Autre",
    "lockScreen": "Verrouillage",
    "childLock": "Verrouillage enfant",
    "energySaving": "Économie d'énergie",
    "signalSourceSwitching": "Source d'entrée",
    "volumeAdjustment": "Haut-parleur",
    "brightAdjustment": "Luminosité",
    "other": "Autres fonctionnalités",
    "otherFunction": "Fonction",
    "send": "Envoyer",
    "ON": "ON",
    "OFF": "OFF",
    "_POWERA": "Display Power",
    "_POWERB": "External Power",
    "_MAGNETICLOCK": "MAGNETICLOCK",
    "_HDMI1": "HDMI in 1",
    "_HDMI2": "HDMI in 2",
    "_HDMI3": "HDMI in 3",
    "_HDMIA": "HDMI out A",
    "_HDMIB": "HDMI out B",
    "_HDMIC": "HDMI out C",
    "_AIR": "Climatisation",
    "titleDevices": "Filtre de groupes:",
    "content": "Rechercher",
    "selectALL": "Sélectionner TOUT",
    "SelectRecentPage": "Sélectionner la page actuelle",
    "controlPanel": "Centre de contrôle",
    "displayInputSwitch": "Commutateur d'entrée d'affichage",
    "chooseINPUTSources": "Choisir les sources d'ENTRÉE",
    "speakerVolume": "Volume audio",
    "bass": "Basse",
    "treble": "Aigu",
    "MICVolume": "Volume MIC",
    "AirConditioning": "Climatisation",
    "model": "Modèle",
    "setTemp": "Température réglée",
    "fanSpeed": "Vitesse du ventilateur",
    "bold": "Balayage",
    "projectionScreen": "Écran de projection",
    "electronicLock": "Verrou électrique",
    "electronicLock1": "Verrou électrique",
    "selectDevices": "Veuillez sélectionner un appareil ou un groupe d'appareils",
    "isCompelType": "Le contrôle de l'appareil est indisponible en raison de la diffusion obligatoire, veuillez réessayer plus tard.",
    "mainPower": "Alimentation principale",
    "extraPower": "Alimentation supplémentaire",
    "power": "Puissance",
    "hdmiBroadcast": "Diffusion",
    "equipmentState1": "Allumer",
    "equipmentState2": "Éteindre",
    "equipmentState3": "Hors ligne",
    "main": "Principal",
    "external": "Externe",
    "ProjectionScreen": "Écran de projection",
    "UP": "MONTER",
    "DOWN": "DESCENDRE",
    "LOCK": "VERROUILLER",
    "UNLOCK": "DÉVERROUILLER",
    "PleaseDevice": "Veuillez sélectionner un ou plusieurs appareils à gauche",
    "RemoteControl": "Télécommande",
    "Action": "Action",
    "Devicefilter": "Filtre d'appareil",
    "DeviceStatus": "Statut",
    "DeviceType": "Type",
    "currentAudioSource": "Source audio actuelle",
    "audioSwitching": "Commutateur de sortie audio"
  },
  "broadcast": {
    "isBoarding": "(Dans la diffusion)",
    "last3Days": "DERNIERS 3 JOURS",
    "last7Days": "DERNIERS 7 JOURS",
    "last30Days": "DERNIERS 30 JOURS",
    "historyRecord": "Historique",
    "SelectDestination": "1.Sélectionner la destination",
    "BroadcastingConsole": "2.Console de diffusion",
    "Notification": "Notification",
    "btnStop": "Arrêter",
    "btnStart": "Démarrer",
    "Letters60": "(moins de 60 caractères)",
    "Letters300": "(moins de 300 caractères)",
    "LastingTime": "Durée :",
    "Title": "Titre :",
    "Content": "Contenu :",
    "Cannotquit": "Diffusion obligatoire",
    "ChooseMedia": "Sélectionner un fichier média",
    "Broadcasting": "Diffusion",
    "dialogTitle": "Ressources vidéo et audio",
    "SortBy": "Trier par",
    "btnBake": "Retour à la page précédente",
    "cancel": "Annuler",
    "confirm": "Confirmer",
    "save": "Sauvegarder",
    "coxAll": "Tout",
    "PublicCloud": "Stockage public",
    "IndividualCloud": "Stockage personnel",
    "selFile": "Veuillez sélectionner un fichier ou un groupe.",
    "StopBroadcast": "Arrêter la diffusion",
    "StartBroadcasting": "Démarrer la diffusion",
    "StopBroadcasting": "Arrêter la diffusion",
    "ForceQuit": "Forcer la fermeture",
    "PleaseMediaFile": "Veuillez sélectionner un fichier média",
    "PleaseDevice": "Veuillez sélectionner un appareil",
    "broadcast_0": "Démarrer la diffusion",
    "broadcast_2500": "Le nombre maximum d'appareils connectables au serveur multimédia est dépassé",
    "broadcast_2501": "Erreur de fichier de diffusion",
    "broadcast_2502": "Diffusion terminée",
    "broadcast_2503": "Impossible d'obtenir les informations du serveur multimédia",
    "broadcast_2510": "Attention! Vous êtes actuellement en période d'essai, jusqu'à 3 appareils terminaux peuvent recevoir des commandes de diffusion. Veuillez vérifier le nombre d'appareils que vous avez sélectionnés.",
    "broadcast_2018": "Le service de diffusion est fermé.",
    "broadcast_2019": "Le service de diffusion a expiré.",
    "broadcast_2512": "Dépassement de la limite de quantité de modèles.",
    "broadcast_2513": "Diffusion d'urgence en cas d'incendie.",
    "broadcast_2514": "Veuillez évacuer par la sortie d'urgence et la sortie de secours vers un endroit sûr selon le plan d'évacuation incendie.",
    "broadcast_2006": "Appareil non trouvé.",
    "broadcast_2": "Le service de disque est anormal.",
    "broadcast_2515": "Sélectionnez un appareil qui n'a pas de capacités de diffusion.",
    "broadcast_2516": "Sélectionnez des fichiers qui dépassent la résolution maximale prise en charge par NMP.",
    "broadcast_2517": "Sélectionnez des fichiers qui dépassent la résolution maximale prise en charge par NDP500.",
    "broadcast_Title": "Alerte de diffusion.",
    "broadcast_TitleNDP500": "Alerte de diffusion NDP500.",
    "broadcast_content": "L'appareil prend en charge jusqu'à 4K@30FPS, avec une résolution optimale de 1080P@30FPS.",
    "broadcast_contentNDP500": "NDP500/600 prend en charge jusqu'à 1080P@30FPS, avec une résolution optimale de 720P@30FPS.",
    "broadcast_noSupported": "Les vidéos sélectionnées suivantes ne sont pas prises en charge pour la diffusion :",
    "broadcast_noSupportedNDP500": "Les vidéos sélectionnées suivantes ne sont pas prises en charge pour la diffusion sur NDP500/600 :"
  },
  "resources": {
    "uploadNameLengthError": "Le nom du fichier téléchargé ne peut pas dépasser 100 mots !",
    "onUploadFile": "Aucun fichier à télécharger",
    "open": "Ouvrir",
    "fold": "Plier",
    "close": "Fermer",
    "PublicCloud": "Stockage public",
    "IndividualCloud": "Stockage personnel",
    "TransfersHistory": "Historique des transferts",
    "btnDownload": "Télécharger",
    "btnDelete": "Supprimer",
    "btnUploadFile": "Télécharger le fichier",
    "btnNewFolder": "Nouveau dossier",
    "btnBake": "Retour à la précédente",
    "coxAll": "Tout",
    "uploadError": "La taille du fichier téléchargé ne peut pas dépasser 1 Go !",
    "MD5": "Vérification MD5",
    "merge": "Fusionner",
    "transcoding": "Transcodage",
    "uploadFailed": "Échec du téléchargement",
    "fileError": "Erreur de lecture du fichier, veuillez vérifier le fichier.",
    "tableName": "Nom",
    "tableSize": "Taille",
    "tableType": "Type",
    "tableTimeAdded": "Temps d'ajout",
    "tableAction": "Action",
    "btnRename": "Renommer",
    "btnMoveTo": "Déplacer vers...",
    "ClearAll": "Tout effacer",
    "cancel": "Annuler",
    "confirm": "Confirmer",
    "save": "Sauvegarder",
    "addSuccess": "Ajouté avec succès !",
    "addError": "Échec de l'ajout !",
    "editSuccess": "Modification réussie !",
    "editError": "Échec de la modification !",
    "delSuccess": "Suppression réussie !",
    "delError": "Échec de la suppression !",
    "diskError3000": "La taille totale de l'espace a été dépassée, l'opération a échoué !",
    "diskError3001": "L'espace public utilisé a été dépassé, l'opération a échoué !",
    "diskError3002": "L'espace personnel utilisé a été dépassé, l'opération a échoué !",
    "diskError3003": "Impossible de trouver les données, veuillez vérifier si le serveur multimédia est lié !",
    "diskError3004": "Le nom du dossier existe déjà !",
    "diskError3005": "Échec de l'obtention du dossier !",
    "diskError3006": "Au même niveau, vous ne pouvez pas créer plus de 99 dossiers !",
    "diskError3007": "Le même nom de fichier existe et la modification a échoué !",
    "diskError3008": "Le même nom de dossier existe et la modification a échoué !",
    "diskError3009": "Le fichier dépasse l'espace restant et l'upload a échoué !",
    "diskError3010": "Échec du téléchargement !",
    "diskError3011": "La vérification du fichier a échoué, veuillez télécharger à nouveau le fichier !",
    "diskError3012": "Échec de l'obtention de l'adresse du cloud privé, l'opération a échoué !",
    "diskError3013": "Les combinaisons de fichiers multiples ne doivent pas dépasser 100 Mo, les fichiers volumineux doivent être téléchargés séparément !",
    "diskError3014": "Échec de la compression, veuillez sélectionner à nouveau le fichier à télécharger !",
    "diskError3015": "Vous avez besoin d'une autorisation pour effectuer cette action",
    "downloadError": "Échec du téléchargement !",
    "mobileError": "Échec du déplacement !",
    "root": "Tous les fichiers",
    "Name": "Nom",
    "Size": "Taille",
    "Type": "Type",
    "uploadFile": "Télécharger le fichier",
    "newFolder": "Nouveau dossier",
    "tableTime": "Temps",
    "permission": "Permissions insuffisantes !",
    "notifyTitle": "Notification",
    "notifyContent": "L'utilisateur n'a pas les autorisations suffisantes pour y accéder !",
    "sortFileName": "Nom du fichier",
    "sortTime": "Temps",
    "sortSize": "Taille",
    "sortType": "Type",
    "moveTo": "Déplacer vers",
    "test": "Nouveau",
    "delTitle": "Supprimer ?",
    "delTitleContent": "Les éléments sélectionnés seront supprimés de la base de données. L'opération ne peut pas être annulée. Êtes-vous sûr de vouloir continuer ?",
    "delCancelButton": "Annuler",
    "delConfirmButton": "Confirmer"
  },
  "userMge": {
    "userName": "Nom d'utilisateur :",
    "jobNumber": "ID Employé :",
    "email": "Email :",
    "phone": "Téléphone :",
    "group": "Groupe :",
    "oldPassword": "Ancien mot de passe :",
    "newPassword": "Nouveau mot de passe :",
    "confirmNewPassword": "Confirmer le nouveau mot de passe :",
    "btnSave": "Enregistrer les modifications",
    "titleChangePassword": "Changer le mot de passe",
    "titleMyProfile": "Mon profil",
    "name": "Surnom :",
    "error1400": "Le compte (personnalisé) existe déjà, l'opération a échoué !",
    "error1401": "Le compte (généré par le système) existe déjà, l'opération a échoué !",
    "error1402": "Le groupe n'existe pas, l'importation a échoué !",
    "error1403": "Erreur de données",
    "error1404": "Permissions insuffisantes",
    "selUser": "Veuillez sélectionner un utilisateur !",
    "error1405": "Échec de la récupération du rôle",
    "error1406": "Le format des données d'informations utilisateur importées est incorrect",
    "error1407": "L'email existe déjà, l'opération a échoué.",
    "error1408": "Le téléphone existe déjà, l'opération a échoué.",
    "editSuccess": "Enregistré avec succès !",
    "ChangePassword": "Changer le mot de passe",
    "UserPrivacyAgreement": "Politique de confidentialité des utilisateurs"
  },
  "information": {
    "_2602": "Dispositif hors ligne",
    "_2603": "Échec de la diffusion",
    "_2604": "La diffusion a été interrompue",
    "_2605": "L'espace de stockage est plein",
    "_2606": "il y a quelques minutes",
    "_2607": "il y a quelques heures",
    "_2609": "échec, veuillez ",
    "_2609_a": "cliquez ici ",
    "_2609_time": "pour le traiter à temps",
    "userType": "Administrateur",
    "unreadNoticeFirst": "Lire d'abord les notifications",
    "sortByTime": "Trier par date",
    "coxRead_1": "Lu",
    "coxRead_0": "Non lu",
    "allCoxRead": "Tout marquer comme lu",
    "load": "Chargement...",
    "noData": "Plus de données",
    "viewALLMessages": "Voir TOUTES les notifications"
  },
  "input": {
    "select": "Veuillez sélectionner",
    "thisField": "Ce champ doit être rempli.",
    "titleShooleNub60": "moins de 60 caractères",
    "titleShooleNub300": "moins de 300 caractères",
    "Offline": "Hors ligne"
  },
  "schedule": {
    "OnlyManual": "Seulement Manuel",
    "runStartNow": "Exécuter la tâche",
    "runStopNow": "Arrêter la tâche",
    "tackExecutionStart": "Tâche en cours",
    "tackExecutionStop": "Exécution de la tâche arrêtée",
    "dehumidification": "Déshumidification",
    "airSupply": "Alimentation en air",
    "masterControl": "principal :",
    "powerSupply": "Puissance",
    "lockScreen": "Verrouiller",
    "RecordingControl": "Contrôle d'enregistrement",
    "RecordingControlSystem": "Système de capture de conférence",
    "LiquidCrystal": "Écran LCD interactif",
    "projector": "Projecteur",
    "othertype": "Autre",
    "childLock": "Verrouillage enfant",
    "energySaving": "Économie d'énergie",
    "signalSourceSwitching": "Source d'entrée",
    "other": "Autres fonctionnalités :",
    "otherFunction": "Fonction",
    "send": "Envoyer",
    "ON": "ALLUMÉ",
    "OFF": "ÉTEINT",
    "btnAddSchedule": "Restaurer",
    "EditSchedulelist": "Éditer le planificateur",
    "AddSchedulelist": "Ajouter un planificateur",
    "RestoreSchedulelist": "Restaurer",
    "btn": "Annuler",
    "btnNewList": "Nouveau planificateur",
    "ListName": "Nom",
    "Cannotquit": "Obligatoire",
    "NOCannotquit": "NON",
    "ListValidityPeriod": "Période de validité",
    "ListDescription": "Description",
    "currentSchedule": "Liste des planificateurs",
    "historySchedule": "Liste des historiques",
    "selectTime": "Temps",
    "selectTimeTable": "Temps",
    "taskType": "Type de tâche",
    "selectBroadcasting": "Diffusion",
    "selectDeviveControl": "Contrôle de périphérique",
    "newSchedule": "Nouvelle tâche",
    "newChecklist": "Nouvelle liste de contrôle",
    "titleStatus": "Statut",
    "titleType": "Type",
    "titleStartTime": "Heure de début",
    "titleEndTime": "Heure de fin",
    "titleRepeat": "Répéter",
    "titleName": "Nom",
    "titleAction": "Action",
    "tableEnabled": "Activé",
    "tablePaused": "En pause",
    "tableEdit": "Éditer",
    "tableDelete": "Supprimer",
    "tableVolumeEdit": "Volume de diffusion",
    "tableBroadcastTitle": "Titre",
    "tableBroadcastContent": "Contenu",
    "tableBroadcastList": "Liste",
    "tableBroadcast": "Obligatoire",
    "btnRemoveCompletely": "Supprimer complètement",
    "btnEnabled": "Tâche activée",
    "btnPaused": "Désactiver la tâche",
    "btnDelete": "Supprimer",
    "repeat0": "LUN",
    "repeat1": "MAR",
    "repeat2": "MER",
    "repeat3": "JEU",
    "repeat4": "VEN",
    "repeat5": "SAM",
    "repeat6": "DIM",
    "dialogTitleAdd": "Nouvelle tâche de contrôle des appareils",
    "dialogTitleEdit": "Modifier la tâche de contrôle des appareils",
    "newBroadcastingSchedule": "Nouvelle tâche de diffusion",
    "editBroadcastingSchedule": "Modifier la tâche de diffusion",
    "chooseDevice": "Choisir un appareil",
    "timeSetting": "Réglage de l'heure",
    "controlBroadcasting": "Option de diffusion",
    "controlOption": "Option de contrôle",
    "scheduleName": "Nom de la tâche :",
    "destination": "Destination",
    "timeTilte": "Temps",
    "repeatTitle": "Répéter",
    "dialogRepeat0": "LUN",
    "dialogRepeat1": "MAR",
    "dialogRepeat2": "MER",
    "dialogRepeat3": "JEU",
    "dialogRepeat4": "VEN",
    "dialogRepeat5": "SAM",
    "dialogRepeat6": "DIM",
    "dialogOnceType": "Une fois",
    "dialogRepeatType": "Répéter",
    "Manual": "Manuel",
    "ManualContent": "Vous pouvez exécuter ces tâches manuellement une fois que vous avez terminé la configuration.",
    "mainPower": "Puissance principale",
    "powerControl": "Contrôle de puissance",
    "tableDisplayInputSwitch": "Commutation d'entrée d'affichage",
    "tableAirConditioning": "Climatisation",
    "tableProjectionScreen": "Écran de projection",
    "tableElectronicLock": "Verrouillage électrique",
    "interactiveFlatPanel": "Panneau plat interactif",
    "displayInputSwitch": "Commutation d'entrée d'affichage",
    "speakerVolume": "Volume audio",
    "MICVolume": "Volume MIC",
    "ProjectionScreen": "Écran de projection",
    "ElectronicLock": "Verrouillage électrique",
    "AirConditioning": "Climatisation",
    "AirConditioningPower": "Puissance",
    "AirConditioningModel": "Modèle",
    "AirConditioningTEMP": "Température",
    "AirConditioningFanSpeed": "Vitesse du ventilateur",
    "OPEN": "OUVRIR",
    "CLOSE": "FERMER",
    "UP": "HAUT",
    "DOWN": "BAS",
    "PowerOFF": "ÉTEINT",
    "PowerON": "ALLUMÉ",
    "ModelAuto": "Automatique",
    "ModelCool": "Froid",
    "ModelHeat": "Chaud",
    "ModelAir": "Côté air",
    "TEMPLow": "Faible",
    "TEMPMiddle": "Moyenne",
    "TEMPHigh": "Élevée",
    "btnSave": "Enregistrer",
    "btnNext": "SUIVANT",
    "StartTime": "Heure de début",
    "StopTime": "Heure de fin",
    "Mandatory": "Obligatoire",
    "Video": "Vidéo et Audio",
    "Notification": "Notification",
    "btnFile": "Sélectionner un fichier média",
    "LastingTime": "Durée",
    "textTitle": "Titre",
    "textContent": "Contenu",
    "textTitleLetters": "Moins de 60 caractères",
    "textContentLetters": "Moins de 320 caractères",
    "CannotquitYES": "OUI",
    "CannotquitNo": "Non",
    "YES": "Êtes-vous sûr de vouloir supprimer ce programme ?",
    "No": "Le programme supprimé sera déplacé vers la liste historique et pourra être restauré",
    "delTitleContent": "Supprimer le programme ?",
    "delTitleListContent": "La suppression du programme entraînera la suppression des tâches associées, veuillez confirmer.",
    "deleListTitle": "Êtes-vous sûr de vouloir supprimer ce programme ?",
    "delTitleListContent1": "Supprimer ?",
    "deleListTitle1": "Confirmer",
    "delTitle": "TOUT",
    "btnConfirm": "Diffusion",
    "coxAll": "Contrôle de l'appareil",
    "coxBroadcasting": "OUI",
    "coxDeviveControl": "NON",
    "rdMandatory": "Date de début",
    "noRdMandatory": "Date de fin",
    "startDate": "-",
    "endedDate": "Type",
    "or": "Choisir l'heure",
    "broadcastingType": "Choisir la date",
    "ChooseTime": "Nouveau programme",
    "ChooseDate": "Modifier le programme",
    "newScheduleList": "Nom",
    "editScheduleList": "Période de validité",
    "listName": "Description",
    "listValidityPeriod": "Annuler",
    "listDescription": "Confirmer",
    "cancel": "Annuler",
    "confirm": "Confirmer",
    "save": "Enregistrer",
    "addSuccess": "Ajout réussi !",
    "addError": "Échec de l'ajout !",
    "editSuccess": "Modification réussie !",
    "editError": "Échec de la modification !",
    "delSuccess": "Suppression réussie !",
    "delError": "Échec de la suppression !",
    "restoreSuccess": "Liste des horaires restaurée avec succès",
    "restoreError": "Échec de la récupération de la liste des horaires",
    "restoreTitleContent": "Cette heure entre en conflit avec l'heure du programme dans la liste, veuillez sélectionner à nouveau",
    "Enabled": "Activé",
    "Paused": "En pause",
    "Title": "Titre :",
    "Content": "Contenu :",
    "errorScheduleNameRequired": "Le nom de la tâche doit être rempli",
    "errorDeviceRequired": "Veuillez sélectionner le périphérique cible",
    "deleTitle": "Êtes-vous sûr de vouloir supprimer cette tâche ?",
    "loopList": "Liste de boucles",
    "errorPleaseDateRange": "Veuillez sélectionner une plage de dates",
    "addError_2009": "Nom du planificateur en double",
    "conflicts": "L'heure de la tâche entre en conflit avec la suivante :",
    "Pleaseagain": "Veuillez entrer à nouveau",
    "errorScheduleName": "Nom de la tâche",
    "errorListName": "Nom du planificateur",
    "today": "Aujourd'hui",
    "yesterday": "Hier",
    "thisWeek": "Cette semaine",
    "lastWeek": "La semaine dernière",
    "lastMonth": "Le mois dernier",
    "thisMonth": "Ce mois-ci",
    "times": "Fois",
    "TimeConflicts": "Conflits de temps",
    "editError_2006": "Périphérique non trouvé",
    "editError_2010": "Nom de tâche dupliqué",
    "editError_2100": "La tâche a expiré, impossible de démarrer.",
    "ListTimeExpired": "Le temps du planificateur a expiré, veuillez sélectionner à nouveau",
    "TimeExpired": "Temps expiré",
    "ControlOption": "Option de contrôle manquante",
    "Pleaseleastone": "Veuillez sélectionner au moins une option de contrôle",
    "Enter": "Entrer",
    "TitleFilled": "Le titre doit être rempli",
    "ContentFilled": "Le contenu doit être rempli",
    "PleaseMediaFile": "Veuillez sélectionner un fichier média",
    "PleaseSchedule": "Veuillez sélectionner une tâche",
    "delTitleScheduleContent": "La tâche supprimée ne peut pas être récupérée.",
    "deleTitleSchedule": "Êtes-vous sûr de vouloir supprimer cette tâche ?",
    "deleteScheduleTitle": "Veuillez sélectionner la tâche à supprimer",
    "PleaseFillColumn": "Veuillez remplir le nom du planificateur",
    "PleaseDate": "Veuillez sélectionner la date",
    "Previous": "Précédent",
    "RemoteControl": "Contrôle à distance",
    "taskhasexpired": "Cette tâche a expiré, veuillez contacter le créateur pour mettre à jour l'heure.",
    "execute": "Exécuter",
    "broadcastingList": "Liste de diffusion",
    "volumeSuccess": "Volume réglé avec succès",
    "volumeFailed": "Échec du réglage du volume"
  },
  "live": {
    "StreamingRoom": "Salle de streaming",
    "btnAddNewRoom": "Ajouter une nouvelle salle",
    "Steaming": "Streaming",
    "Creater": "hôte :",
    "Address": "Adresse RTMP :",
    "StreamingURL": "URL du streaming en direct :",
    "DestinationNMP": "Sélectionner la destination NMP :",
    "stop": "ARRÊTER",
    "stat": "DÉMARRER",
    "btnCope": "Cliquez pour COPIER",
    "QRcode": "QR Code",
    "Refresh": "Rafraîchir",
    "AddNewRoomTitle": "Ajouter une nouvelle salle de streaming",
    "editNewRoomTitle": "Modifier la salle de streaming",
    "roomName": "Nom de la salle :",
    "cancel": "Annuler",
    "confirm": "Confirmer",
    "save": "Sauvegarder",
    "delTitleContent": "Êtes-vous sûr de vouloir supprimer cet horaire ?",
    "delTitle": "Supprimer ?",
    "delCancelButton": "Annuler",
    "delConfirmButton": "Confirmer",
    "addSuccess": "Ajout réussi !",
    "addError": "Échec de l'ajout !",
    "editSuccess": "Modification réussie !",
    "editError": "Échec de la modification !",
    "delSuccess": "Suppression réussie !",
    "delError": "Échec de la suppression !",
    "Stopstreaming": "Arrêter le streaming",
    "Startstreaming": "Démarrer le streaming",
    "error2504": "Impossible d'obtenir l'adresse de streaming en direct du serveur multimédia",
    "error2505": "Nom de la salle de streaming dupliqué",
    "error2506": "L'appareil est occupé par un autre signal de streaming",
    "error1900": "Le paramètre d'accès est vide",
    "error2503": "Impossible d'obtenir les informations du serveur multimédia",
    "error2507": "Adresse de streaming en direct dupliquée",
    "copySuccess": "Le contenu a été copié dans le presse-papiers.",
    "copyError": "Le navigateur ne prend pas en charge la copie automatique",
    "flashControl": "Flash n'est pas installé ou activé. Veuillez essayer après l'installation ou l'activation de Flash.",
    "liveStreaming": "Aucune source de streaming en direct trouvée.",
    "btnflash": "Installer/Activer",
    "serverAddress": "Adresse du serveur",
    "addressKey": "Clé :",
    "watchingAddress": "Adresse de visionnage",
    "audioOnly": "Audio uniquement",
    "enterTheKey": "La clé doit être remplie."
  },
  "guidepages": {
    "next": "Prochain appareil de contrôle",
    "next1": "Prochain essai de contrôle",
    "next2": "Prochain diffusion",
    "next3": "Prochain démarrer la diffusion",
    "next4": "Prochain arrêter la diffusion",
    "next5": "Prochain diffusion texte",
    "next6": "Prochain configuration de la tâche",
    "next7": "Prochain ajouter une nouvelle tâche",
    "next8": "Prochain liste des historiques",
    "next9": "Prochain stockage en nuage",
    "next10": "Prochain diffusion en direct",
    "next11": "Prochain configurer la diffusion en direct",
    "exit": "Quitter",
    "guideContent": "Contenu du guide",
    "btnHomepage": "Page d'accueil",
    "btnDevices": "Appareils",
    "btnBroadcast": "Diffusion",
    "btnSchedule": "Calendrier",
    "btnResources": "Ressources",
    "btnStreaming": "Direct",
    "btnPrevious": "Précédent"
  },
  "privacy": {
    "PrivacyPolicy": "Q-NEX Privacy Policy",
    "Byusing": "By using the Q-NEX service, you are trusting us to process your information. We understand that this responsibility is important, so we have been committed to protecting your information and giving you control.",
    "whatinformation": "This Privacy Policy is designed to help you understand what information we collect, why it is collected, and how you manage your information.",
    "EffectiveDate": "Effective Date: January 1, 2020",
    "title1": "Q-NEX Respects Your Privacy",
    "title1Respects1": "Returnstar Interactive Technology Group Co.,Ltd. and its sub-brand (collectively “Q-NEX”, “we” or “us”) respect your privacy and understand that the processing and security of your personal data is important to you. Please review the full Privacy Policy below for more complete details on how we collect, use, share, and protect your personal data, as well as the choices you have regarding our use and sharing of your personal data, along with other important considerations.",
    "title1Respects2": "This Privacy Policy explains Q-NEX’s practices regarding the processing (such as the collection, use, storage, copy or disclosure) of your personal data received: (i) through our website https://www.qnextech.com (“Website”), email, and other written or in person communications; (ii) in the context of all our commercial relations with customers, end-users, dealers, distributors, suppliers, contractors, agents or representatives; and (iii) in the normal course of any other potential business relationship. We commit to comply with our obligations under all applicable Privacy and Data Protection Laws, as described below, including but not limited to the Provisions on Protection of Personal Information of Telecommunications and Internet Users, and to respect your rights whenever we are processing your personal data.",
    "title2": "Privacy and Data Protection",
    "title2Respects1": "“Personal Data” means any information that identifies, or can be used to identify, an individual.",
    "title2Respects2": "“Privacy and Data Protection Laws” means any and/or all laws, rules, directives and regulations, on any local, provincial, state, federal or national level within and outside the People's Republic of China, pertaining to data privacy, data security and/or the protection of Personal Data. Among them, laws and regulations outside China include but not limited to: (a) the General Data Protection Regulation (GDPR) and each European Union Member States’ national implementation thereof; (b) the Australian Privacy Act 1988 (Cth) and the Australian Privacy Amendment (Enhancing Privacy Protection Act) (2012); (c) the Belgian Privacy Law of 8 December 1992; (d) the Canadian Personal Information Protection and Electronic Documents Act, SC 2000, c 5 (PIPEDA); (e) the Personal Data Protection Act 2012 of Singapore (PDPA); (f) additional privacy and data protection laws applicable to a data subject’s location; and (g) any successor legislation or regulations applicable thereto.",
    "title3": "When Do We Collect Your Personal Data?",
    "title3Respects1": "Q-NEX may collect your personal data when you communicate with us by phone, e-mail, the Website or otherwise, in the context of:",
    "title3a": "Browsing our Website or visiting our social media sites;",
    "title3b": "Corresponding with Q-NEX;",
    "title3c": "Visiting one of our offices, events or facilities;",
    "title3d": "Registering for and/or participating in our conferences, events, training or other activities;",
    "title3e": "Requesting information, support, service, materials, assistance or other inquiries;",
    "title3f": "Subscribing to a newsletter or other mailing list;",
    "title3g": "Exchanging business cards;",
    "title3h": "Completing Website contact forms, questionnaires, surveys, or contest entry forms or otherwise participating in these activities;",
    "title3i": "Engaging in commercial relationships or other collaboration;",
    "title3j": "Ordering or registering Q-NEX products;",
    "title3k": "Creating or registering an account;",
    "title3l": "Uploading or downloading files;",
    "title3m": "Verification of your identity as a data subject; or",
    "title3n": "Using Q-NEX products that are connected to the Internet, including mobile apps, cloudware, and certain hardware devices.",
    "title4": "Which Types of Personal Data are Processed by Us?",
    "title4Respects1": "Q-NEX may process the following personal data:",
    "title4a": "Name, surname, title, company, email address, phone number (mobile and landline), address, signature and other contact information;",
    "title4b": "IP addresses;",
    "title4c": "Location data;",
    "title4d": "Cookie ID;",
    "title4e": "Language;",
    "title4f": "Personal preferences regarding communications and/or products and services;",
    "title4g": "Financial details (e.g. payment information, bank account number, and credit information);",
    "title4h": "Personal data regarding projects using Q-NEX products and services;",
    "title4i": "Personal data provided in your submissions, responses and feedback;",
    "title4j": "Personal data regarding your interactions with Q-NEX, including your use of the Website and of Q-NEX’s products or services;",
    "title4k": "Social media data, images, photos, and camera footage; and",
    "title4l": "Any other personal data provided by you or by your authorized Q-NEX dealer or service provider.",
    "title4Respects2": "For the avoidance of doubt, Q-NEX does not collect any sensitive personal data, such as racial or ethnic origin; political opinions; religious or philosophical beliefs; genetic characteristics; health information; sexual preferences; information about children; criminal convictions; or biometric data, and we explicitly ask that you not provide us with such data in your responses or feedback to us.",
    "title5": "How Do We Use Your Personal Data?",
    "title5Respects1": "In order to better manage our own business needs and to better communicate with you, we may collect, analyze, use and otherwise process your personal data for the following purposes:",
    "title5a": "To respond to your inquiries, questions and other requests;",
    "title5b": "To optimize and manage the quality and content of our Website, including the ability to personalize and secure your Website experience;",
    "title5c": "To create and maintain your website, customer and product accounts and registrations;",
    "title5d": "To provide you with marketing, advertising, promotions, programs, offers and other opportunities; including newsletters, information on products and services, subscriptions, training, updates and direct marketing, which may be targeted, based on your communication preferences;",
    "title5e": "To conduct customer satisfaction studies, surveys and other market research;",
    "title5f": "To manage our events and activities, and invite you to events;",
    "title5g": "To register visitors to our offices, facilities and events;",
    "title5h": "To create promotional materials, including videos, photos, articles, case studies, newsletters and other materials regarding projects or events;",
    "title5i": "To provide products, services, training, technical support, customer service and other assistance;",
    "title5j": "To manage and perform our agreements and obligations;",
    "title5k": "To respond to and follow up on business leads, opportunities, and contacts;",
    "title5l": "To process payments, orders, invoicing, returns, collection and other requests;",
    "title5m": "To provide pricing, quotations and custom configurations of our products and services;",
    "title5n": "To grant you access to our software, training, technical information and other proprietary content;",
    "title5o": "To evaluate, troubleshoot, analyze and improve the use, functionality, features, and performance of our products, services, training, technical support and customer service;",
    "title5p": "To gather, analyze and maintain configuration and backup data regarding our products and services;",
    "title5q": "To facilitate planning, analytics, forecasting and reporting regarding our products and services;",
    "title5r": "To use for our internal business operations and processes, including business and financial recordkeeping, data management and business continuity; and",
    "title5s": "To meet our legal and regulatory obligations.",
    "title6": "Which Legal Basis Applies To Our Processing Of Your Personal Data?",
    "title6Respects1": "The following legal grounds might apply to the processing of your personal data for the purposes mentioned above:",
    "title6a": "Processing is necessary for the performance of your agreement with us or in order to take all pre-contractual steps;",
    "title6b": "Processing takes place based upon our legitimate interest (comply with obligations, maintain business records, fraud prevention, network and information security, etc.). When carrying out this type of processing, we strive to strike a balance between this legitimate interest and respect for your privacy;",
    "title6c": "You have given your consent to the processing (e.g. in case of direct marketing, for the processing of analytic cookies and for data transfers to third parties);",
    "title6d": "In order to comply with our legal obligations (such as tax administration and record retention); or",
    "title6e": "In very exceptional circumstances to protect your vital interest or that of someone else.",
    "titel7": "To Whom Do We Disclose Your Personal Data?",
    "title7Respects1": "Q-NEX may disclose your personal data to yourself, to Q-NEX’s affiliates or to third parties, such as payment providers, software providers, cloud partners, transport partners, financial institutions, insurance companies, legal services, or certain other service providers or partners that Q-NEX has a strategic relationship with, in order to fulfill our relationship with you in the most effective way.",
    "title7Respects2": "Q-NEX will not disclose to third parties any personal data you submit for purposes other than those described in this Privacy Policy. If, in the future, we intend to disclose your personal data to third parties for any purpose other than those described in this Privacy Policy we shall inform you thereof in advance and ask your consent if required.",
    "title7Respects3": "Notwithstanding the foregoing, Q-NEX will disclose your personal data to a third party (such as competent authorities) if required to do so by law, during a legal proceeding, or if, in good faith, Q-NEX believes that such action is necessary to comply with certain laws, rules or regulations.",
    "titel8": "Which Guarantees Do We Provide in Case of International Data Transfers?",
    "title8Respects1": "Q-NEX is a global company and we may transfer your information to Q-NEX affiliates, representatives or third party contractors who represent us worldwide. Each affiliate, representative, or third party contractor works closely with Q-NEX, and any transfer of personal data between these associated entities will comply with applicable Privacy and Data Protection Laws.",
    "title8Respects2": "If any transfer of the personal data of residents of the European Economic Area (EEA) is made to a person or entity located in a country outside of the EEA, that is not recognized as providing an adequate level of protection, we will provide for increased information security and appropriate contractual provisions to strengthen data protection. To ensure that any such transfers of the personal data of EEA residents are compliant with the applicable Privacy and Data Protection Laws, we will either (i) conclude a data transfer agreement, based upon the EU model agreements, (ii) adopt binding corporate rules, (iii) rely on legally determined exceptions (such as requesting your explicit consent) or (iv) adopt other mechanisms which have been deemed to provide for the adequate protection of your personal data.",
    "titel9": "How Do We Secure Your Personal Data?",
    "title9Respects1": "We use a variety of security technologies and precautions, such as the Secure Socket Layer (SSL) protocol (encryption), to help protect your personal data from loss, theft, misuse and unauthorized access, in accordance with industry standards. To protect any personal data stored on Q-NEX servers or cloud-based storage, we regularly monitor our systems for vulnerabilities or attacks, and implement up to date information security measures.",
    "title9Respects2": "Access to personal data that is processed by Q-NEX is limited only to those of its employees, contractors and affiliated organizations that need to know that information in order to process it on Q-NEX’s behalf, in accordance with this Privacy Policy, and that have agreed not to disclose it to others.",
    "titel10": "How Long Do We Retain Your Personal Data?",
    "title10Respects1": "Unless a longer retention period is required by law, Q-NEX will retain your personal data for as long as needed to fulfil the relevant purposes described in this Privacy Policy.",
    "titel11": "Use of Cookies",
    "title11Respects1": "Q-NEX uses cookies on our Website, both to enable the site to work properly, and to enhance your experience while visiting our Website. Cookie file(s), which are stored on the hard drive of your computer, enable us to obtain information about your usage of our Website, and to measure and improve the performance of our Website. Cookies enable you to store your preferences, in order to enable our Website to recognize these preferences when you browse our Website.",
    "title11Respects2": "You may refuse to accept cookies by activating the setting on your browser which allows you to refuse cookies. However, if you select this setting you may not be able to access certain sections or features of our Website. Unless you have adjusted your browser setting so that it will refuse cookies, our system will issue cookies to your computer whenever you log on to our Website.",
    "title11Respects3": "When you visit our Website for the first time you will be provided with a link to this cookie policy and will have the opportunity to change your browser settings to refuse cookies. By continuing to browse our website without changing your settings, you agree to our use of cookies as explained in this policy.",
    "title11Respects4GoogleAnalytics": "Google Analytics.",
    "title11Respects4": "We use industry standard web analytics to track visits to our sites, namely those provided by Google Analytics. The information generated by the cookies about your use of our Website (including your IP address) will be transmitted to and stored by Google Analytics on their servers and is handled in accordance with Google’s Privacy Policy which can be accessed at the following link: https://policies.google.com/privacy.",
    "titel12": "Third Party Links on our Website",
    "title12Respects1": "The Website contains links to other websites. Q-NEX is not responsible for the privacy policy of other websites, or the manner in which they store, use or distribute information. Q-NEX encourages you to review the privacy policy of any website you may visit.",
    "titel13": "Children’s Information",
    "title13Respects1": "Q-NEX’s Website is not intended for use by children, and its products and services are not sold to children. In accordance with the Children’s Online Privacy Protection Act, we do not collect or maintain information from persons we know are under 18, and no part of the Website is designed to attract anyone under age 18.",
    "titel14": "What Are Your Rights and How Can You Exercise Them?",
    "title14Respects1": "If you are a natural person, you have the right at all times to be informed about the personal data we process about you, and to the extent authorized under the applicable Privacy and Data Protection Laws, to request access, modification, limitation of processing, transfer or deletion of personal data, or to object to the processing of your personal data, subject to the exceptions within the applicable Privacy and Data Protection Laws.",
    "title14Respects2": "If processing is based solely on your consent, you also have the right to revoke your consent at any time, without prejudice to the lawfulness of processing prior to revocation.",
    "title14Respects3": "Through the contact options listed below, you can exercise the above rights regarding the processing of your personal data by Q-NEX, except in cases where this would require a disproportionate effort on the part of Q-NEX.",
    "title14Respects4": "Please feel free to use the contact information listed below if you have any additional concerns regarding your personal data or your exercise of the above rights, and we will do our best to assist you.",
    "title14Respects5": "If you contact us to exercise one of your rights under the applicable Privacy and Data Protection Laws, we will reply within one (1) month. In certain exceptional circumstances, we may take up to three (3) months to fully respond to you, but in such case we shall inform you why we require additional time to respond in our initial reply.",
    "title14Respects6": "If we are unable to resolve an inquiry or request, where applicable, you may have the right to lodge a complaint with the local data protection authority.",
    "titel15": "Stay Informed of Changes in Our Privacy Policy",
    "title15Respects1": "In a world in which technology and legislation is constantly changing, this Privacy Policy may also change. We invite you to always consult the latest version of this policy, posted at https://www.qnextech.com/legal, and we will inform you of any changes via our Website or other common communication channels.",
    "titel16": "Contact Q-NEX",
    "title16Respects1": "If you have questions and/or comments about this Privacy Policy or the manner in which Q-NEX collects, uses and/or processes your personal data, please contact us:",
    "title16Respects2": "Via e-mail: info@qnextech.com"
    }
}



// WEBPACK FOOTER //
// ./src/lang/fr.js